<template>
  <div id="app">
    <NavBar />
    <div class="main">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    NavBar,
    Footer
  }
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #60b347;
  --primary-color: #eeeeee;
  --secondary-color: #2f650f;
  font-size: 16px;
}

html,
body {
  overflow-x: hidden;
  min-height: calc(100vh - 50px);
  scroll-behavior: smooth;
  font-family: "Poppins", sans-serif;
  font-size: 1.04rem;
  font-weight: 400;
}

body {
  position: relative;
}

.main {
  margin-top: 70px;
  min-height: calc(100% - 70px - 250px);
  padding-bottom: 250px;
  background-color: var(--secondary-color);
}

#app {
  position: relative;
  min-height: calc(100vh - 70px);
  background-color: var(--secondary-color);
}
</style>



// WEBPACK FOOTER //
// src/App.vue